import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/x-social-media-white-icon.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

//TODO add disclaimer for not owning any images lol
export const Footer = () => {
  const visitorId = localStorage.getItem("visitorId");
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/*<MailchimpForm /> TODO determine if I even want this as a feature*/}
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/egan-trahant-ba7852285"><img src={navIcon1} alt="Icon" onClick={()=> {fetch("/api/statistics", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ visitorId, feature: "linkedin" }),
                });
              }}/></a>
              <a href="https://www.x.com/EganTrahant"><img src={navIcon2} alt="Icon" onClick={()=> {fetch("/api/statistics", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ visitorId, feature: "x" }),
                });
              }}/></a>
              <a href="https://www.instagram.com/egan_trahant/"><img src={navIcon3} alt="Icon" onClick={()=> {fetch("/api/statistics", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ visitorId, feature: "instagram" }),
                });
              }}/></a>
            </div>
            <p>Copyright 2025. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}